class ServiceTimeUpdateLocationsModel extends App.Models.BaseModel { }

App.Models.ServiceTimeUpdateLocations = ServiceTimeUpdateLocationsModel;

class ServiceTimeUpdateServiceTimeTypesModel extends App.Models.BaseModel { }

App.Models.ServiceTimeUpdateServiceTimeTypes = ServiceTimeUpdateServiceTimeTypesModel;
